
export default {
  props: {
    activeID: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    arrowLeft: {
      type: Boolean,
      default: false,
    },
    setupFee: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loaded: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.loaded = true;
    }, 100);
  },
  beforeDestroy() {
    this.loaded = false;
  },
};
